import { useSelector } from 'react-redux';
import { ReduxStore } from 'libs/redux-store/src';
import { get, find } from 'lodash';
import { labelsSelector } from '../../../utils';
import { useMemo } from 'react';

const useConfig = () => {
  const contentFragment = useSelector((store: ReduxStore) => store.contentFragment);
  const config = useSelector((store: ReduxStore) => store.config);
  const labels = useSelector((store: ReduxStore) => get(labelsSelector(store), 'user_info', {}));
  const userInfo = useSelector((store: ReduxStore) => store.user);
  const language = useSelector((store: ReduxStore) => get(store, 'config.locale'));
  const userProfile = useSelector((store: ReduxStore) => store.userProfile);

  // @ts-ignore
  const bannerContent: BannerProps = useMemo(
    () => find(
      get(contentFragment.banner, 'bannerContents'),
      content => get(content, 'bannerId') === config.bannerId
    ),
    [contentFragment.banner, config.bannerId]
  );

  return useMemo(
    () => ({ bannerContent, contentFragment, config, labels, userInfo, language, userProfile }),
    [bannerContent, contentFragment, config, labels, userInfo, language, userProfile]
  );
};

export default useConfig;
